declare const posthog: any;
import '../css/simple-modal.css'
import { getCreditUnionGroups } from './posthog-group'

declare global {
    interface HTMLElement {
        readonly SimpleModal: SimpleModal | undefined;
    }

}

if (!HTMLElement.prototype.SimpleModal) {
    Object.defineProperty(HTMLElement.prototype, 'SimpleModal', {
        get: function () {
            // Use a data attribute to store and retrieve the modal ID
            const modalId = this.getAttribute('data-simple-modal-id');
            return SimpleModal.instances.get(modalId || '');
        }
    });
}

export default class SimpleModal {
    static instances = new Map<string, SimpleModal>();

    modalId: string;
    modalJs: string;
    modalElement: HTMLElement | null;
    backdrop: HTMLElement | null;

    private constructor(triggerElement: HTMLElement) {
        this.modalId = triggerElement.getAttribute('data-simple-modal-trigger') ?? ''
        this.modalJs = triggerElement.getAttribute('data-simple-modal-js') ?? ''
        this.modalElement = null
        this.backdrop = null
    }

    static getInstance(triggerElement: HTMLElement): SimpleModal {
        const modalId = triggerElement.getAttribute('data-simple-modal-trigger') ?? ''
        let instance = SimpleModal.instances.get(modalId);

        if (!instance) {
            instance = new SimpleModal(triggerElement);
            SimpleModal.instances.set(modalId, instance);
        }

        return instance;
    }

    async init() {
        //if (!this.modalElement) {
            // Check if Ajax call
            if (this.modalId.indexOf('/') > -1) {
                let response = await fetch(this.modalId)
                let data = await response.text()

                this.modalElement = document.createElement('div')
                this.modalElement.classList.add('simple-modal')
                this.modalElement.classList.add('simple-modal-href')
                let subEl = document.createElement('div')
                subEl.classList.add('simple-modal-content')
                subEl.style.zIndex = '1000'
                subEl.innerHTML = data
                this.modalElement.appendChild(subEl)
                this.modalElement.style.display = 'block'

                let me = document.querySelector('.simple-modal-href')
                me?.remove()

                // Extract and execute any <script> tags from the fetched HTML
                let tempDiv = document.createElement('div');
                tempDiv.innerHTML = data;
                let scripts = tempDiv.querySelectorAll('script');

                scripts.forEach(script => {
                    let newScript = document.createElement('script');
                    if (script.src) {
                        // External script
                        newScript.src = script.src;
                    } else {
                        // Inline script
                        newScript.textContent = script.textContent;
                    }
                    document.body.appendChild(newScript); // Append and execute the script
                });

                document.body.appendChild(this.modalElement)
            }
            else {
                this.modalElement = document.querySelector(this.modalId) as HTMLElement
            }

            // Append backdrop
            this.backdrop = this.modalElement.querySelector(".simple-modal-backdrop") as HTMLElement;
            if (!this.backdrop) {
                this.backdrop = document.createElement("div")
                this.backdrop.innerHTML = "<div class=\"simple-modal-backdrop\"></div>"
                this.modalElement.appendChild(this.backdrop)
            }

            this.modalElement.querySelectorAll('.simple-modal-close').forEach(closeTrigger => {
                closeTrigger.addEventListener('click', (event) => this.close(event))
            })

            // Run Js
        if (this.modalJs) {
                new Function(this.modalJs)()
            }
        //}
    }

    async open() {
        await this.init()
        if (this.modalElement)
            this.modalElement.style.display = 'block';
    }

    close(event: Event) {
        event.preventDefault()

        if (this.modalElement)
            this.modalElement.style.display = 'none';
    }
}

document.addEventListener('click', (event) => {
    let el = (event.target as HTMLElement).closest('[data-simple-modal-trigger]')

    if (el) {
        event.preventDefault()

        let sm = SimpleModal.getInstance(el as HTMLElement)
        sm.open()

        // PostHog: lead_form_opened — only for StandardLeadSubmissionModal triggers
        const triggerValue = el.getAttribute('data-simple-modal-trigger') ?? ''
        if (triggerValue.includes('StandardLeadSubmissionModal') && typeof posthog !== 'undefined') {
            try {
                const url = new URL(triggerValue, window.location.origin)
                const inventoryVehicleId = url.searchParams.get('inventoryVehicleId') ?? undefined
                const dealershipId = url.searchParams.get('dealershipId') ?? undefined
                const contactId = url.searchParams.get('contactId') ?? undefined

                posthog.capture('lead_form_opened', {
                    vehicle_id: inventoryVehicleId,
                    dealership_id: dealershipId,
                    contact_id: contactId,
                    form_type: contactId ? 'contact_person' : 'vehicle_inquiry',
                    $groups: getCreditUnionGroups(),
                })
            } catch {
                posthog.capture('lead_form_opened', {
                    form_type: 'vehicle_inquiry',
                    $groups: getCreditUnionGroups(),
                })
            }
        }
    }
})